<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row >
        <b-col class="mt-3">
          <h4 style="text-align: center;">Product Lists</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item class="items-warpper mt-3 mb-3">
              <b-row>
                <b-col cols="11">
                  <b-form-input v-model="newplname" placeholder="Add new Product List"></b-form-input>
                </b-col>
                <b-col cols="1">
                  <b-button class='add-btn' variant="outline-dark" @click="addProductList()">+</b-button>
                  <!-- <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="2.5" v-b-popover.hover.left="'Add new Product List'" @click="addProductList()"></b-icon></a> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="10"><b-alert v-if="newplalert" variant="info" v-model="newplalert" dismissible>Please enter a Product List name!</b-alert></b-col>
              </b-row>
            </b-list-group-item >
              <PLList
                v-for="productlist of productlists"
                v-bind:productlist="productlist"
                v-bind:key="productlist.id"
                :productlists="productlists"
                @emit-switch-overlay="switchOverlay"
                @emit-fetch-productlists="fetchMenuProductLists">
              </PLList>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="currentPage" :total-rows="total_product_lists" :per-page="limit" align="center" @change="showoverlay=true; fetchMenuProductLists()"></b-pagination>
          <p style="text-align: center;">Total Product Lists: {{ total_product_lists }}</p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import PLList from '@/components/PLList.vue'
export default {
  name: "MenuProductLists",
  components: {
    PLList
  },
  data() {
    return {
      productlists: [],
      total_product_lists: 0,
      limit: 25,
      currentPage: 1,
      showoverlay: false,
      newplname: '',
      newplalert: false,
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage+"&limit="+this.limit;
    }
  },

  methods: {
    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    async addProductList() {
      if (this.newplname == '') {
        this.newplalert = true;
        return;
      }
      this.showoverlay=true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.newplname
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('productlists',
        body,
        config
      );
      if (data.created == true) {
        this.newplname = '';
        this.fetchMenuProductLists();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the product list, please try again later.', {
          title: 'Error adding product list',
          centered: true
        })
      }
    },

    async fetchMenuProductLists() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("productlists"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        this.productlists = await data.productlists;
        this.total_product_lists = data.total_product_lists;
        this.showoverlay = false;
      } catch(e) {
        console.log(e);
        this.showoverlay = false;
      }
    },

  },

  created: function() {
    // this.showoverlay = true;
    this.fetchMenuProductLists();
  }
}
</script>
